import { toggleValues } from 'platform/site-wide/feature-toggles/selectors';
import FEATURE_FLAG_NAMES from 'platform/utilities/feature-toggles/featureFlagNames';

export const facilitiesPpmsSuppressAll = state =>
  toggleValues(state)[FEATURE_FLAG_NAMES.facilitiesPpmsSuppressAll];

export const facilityLocatorPredictiveLocationSearch = state =>
  toggleValues(state)[
    FEATURE_FLAG_NAMES.facilityLocatorPredictiveLocationSearch
  ];

export const facilityLocatorMobileMapUpdate = state =>
  toggleValues(state)[FEATURE_FLAG_NAMES.facilityLocatorMobileMapUpdate];

export const facilityLocatorAutosuggestVAMCServices = state =>
  toggleValues(state)[
    FEATURE_FLAG_NAMES.facilitiesAutoSuggestVAMCServicesEnabled
  ];

export const showFacilityLocatorNoticeAboutNonVACare = state =>
  toggleValues(state)[
    FEATURE_FLAG_NAMES.showFacilityLocatorNoticeAboutNonVACare
  ];
